import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  gruposRamais: [],
  grupoRamalSelecionado: {},
  ramais: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
